console.log('Scroll hero script loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOMContentLoaded fired');
  
  // Find the hero section
  const heroSection = document.querySelector('.mahj-hero__section');
  
  if (!heroSection) {
    console.log('Hero section not found');
    return;
  }
  
  const background = document.querySelector('.mahj-hero__background');
  const image = heroSection.querySelector('.image-block__image');
  
  console.log('Hero section found:', heroSection);
  console.log('Background found:', background);
  console.log('Image found:', image);
  
  if (!background || !image) {
    console.warn('Missing background or image in mahj-hero section');
    return;
  }
  
  // Set initial state
  image.style.transform = 'translateY(100%)';
  
  // Initialize ScrollMagic Controller
  const controller = new ScrollMagic.Controller();
  
  // Pin the hero section
  const pinScene = new ScrollMagic.Scene({
    triggerElement: heroSection,
    triggerHook: 0,
    duration: '200%' // Pin for 2x the viewport height
  })
  .setPin(heroSection)
  .addTo(controller);
  
  // Animate the image
  const imageScene = new ScrollMagic.Scene({
    triggerElement: heroSection,
    triggerHook: 0,
    duration: '200%' // Same duration as pin
  })
  .on('progress', function(event) {
    const progress = event.progress;
    
    // Calculate translateY: from 100% to -20% (total range of 120%)
    const translateValue = 100 - (progress * 120);
    
    console.log('Progress:', progress.toFixed(2), 'TranslateY:', translateValue.toFixed(2) + '%');
    
    image.style.transform = `translateY(${translateValue}%)`;
    
    // Optional: Change background attachment at the end
    if (progress >= 1) {
      if (background.style.backgroundAttachment !== 'scroll') {
        console.log('Animation complete - switching background to scroll');
        background.style.backgroundAttachment = 'scroll';
      }
    }
  })
  .addTo(controller);
  
  console.log('ScrollMagic scenes created');
  
  // Optional: Add indicators for debugging
  // pinScene.addIndicators({name: "Pin Scene"});
  // imageScene.addIndicators({name: "Image Animation"});
});